module.exports = __webpack_public_path__ + "img/markerRed.bcb06587.png";